import React, { useState, useEffect } from "react";
import { Grid, Button, FormControl, TextField } from "@mui/material";
import "../css/InvoicesFilter.css";
import { MobileDatePicker } from "@mui/x-date-pickers";
import DateLocalizationProvider from "./DateLocalizationProvider";
import { DATE_FORMAT } from "../../utils/constants";
import SnackbarAlert from "./SnackbarAlert";

const InvoicesFilter = ({ selectedTab, onClickApply, onClickClear }) => {
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [showValidationError, setShowValidationError] = useState(false);
  const [errorKey, setErrorKey] = useState(0);

  useEffect(() => {
    setDefaultValue();
  }, [selectedTab]);

  const setDefaultValue = () => {
    setSelectedDate(null);
    setInvoiceNumber("");
  };

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
  };

  const handleInvoiceNumberChange = (event) => {
    setInvoiceNumber(event.target.value);
  };

  const handleClearFilter = () => {
    setDefaultValue();
    onClickClear();
  };

  const handleApplyFilter = () => {
    // Check if at least one filter is selected
    const hasInvoiceNumber = invoiceNumber && invoiceNumber.trim() !== "";
    const hasSelectedDate = selectedDate !== null;

    if (!hasInvoiceNumber && !hasSelectedDate) {
      setErrorKey(prev => prev + 1);
      setShowValidationError(true);
      return;
    }

    // Clear any existing validation error
    setShowValidationError(false);

    // Call the parent's onClickApply function
    onClickApply(selectedDate, invoiceNumber);
  };

  const handleCloseValidationError = () => {
    setShowValidationError(false);
  };

  return (
    <>
      {showValidationError && (
        <SnackbarAlert 
          key={errorKey}
          type="error" 
          onClose={handleCloseValidationError}
        >
          Please select at least one filter before applying
        </SnackbarAlert>
      )}
      <div className="invoices-filter-filter-container">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <FormControl variant="outlined">
                  <div className="invoices-filter-select-header">
                    Invoice number
                  </div>
                  <TextField
                    id="invoices-invoice-number"
                    variant="outlined"
                    placeholder="Enter here"
                    className="invoices-filter-textfield"
                    value={invoiceNumber}
                    onChange={handleInvoiceNumberChange}
                    InputProps={{
                      autoComplete: "off",
                    }}
                  />
                </FormControl>
              </Grid>
              <DateLocalizationProvider>
                <Grid item>
                  <FormControl variant="outlined">
                    <div className="invoices-filter-select-header">
                      Invoice Date
                    </div>
                    <MobileDatePicker
                      id="invoices-filter-invoice-date"
                      className="invoices-filter-datepicker"
                      format={DATE_FORMAT}
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                  </FormControl>
                </Grid>
              </DateLocalizationProvider>
            </Grid>
          </Grid>
          <Grid item>
            <div className="invoices-filter-button-container">
              <Button className="clear" onClick={handleClearFilter}>
                Clear
              </Button>
              <Button
                variant="contained"
                className="apply"
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default InvoicesFilter;
